<template>
  <v-container class="pr-0 pl-0" fluid>

    <v-row>

      <v-col cols="12" v-if="(!listTreinosDoDiaCiclismo || listTreinosDoDiaCiclismo.length < 1)
        && (!listTreinosDoDiaCorrida || listTreinosDoDiaCorrida.length < 1)
        && (!listTreinosDoDiaNatacao || listTreinosDoDiaNatacao.length < 1) && !dialogLoader">
        <v-card class="elevation-10" dense >
          <v-card-text class="text-body-2 font-weight-black">
            Não há treinos registrados hoje para os alunos. 
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card class="elevation-10" dense :disabled="dialogLoader">
          <v-card-text class="text-body-2 font-weight-black">
            <v-icon color="primary" left>mdi-clipboard-list-outline</v-icon>Olá {{ $store.getters.userLogged.name }},
            aqui o resumo do dia de treinos
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" v-for="item in userWithTreinosByCount100" :key="item.id">
        <v-card class="elevation-10 mt-n2" :disabled="dialogLoader">
          <v-card-text class="body-2">
            <v-icon left color="primary">mdi-emoticon-cool-outline</v-icon>{{ item.fullName }}
            tem seu <span class="font-weight-black">100º</span> treino conosco hoje! Dê os parabéns!
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" v-for="item in userWithTreinosByCount500" :key="item.id">
        <v-card class="elevation-10 mt-n2" :disabled="dialogLoader">
          <v-card-text class="body-2">
            <v-icon left color="primary">mdi-emoticon-cool-outline</v-icon>{{ item.fullName }}
            tem seu <span class="font-weight-black">500º</span> treino conosco hoje! Dê os parabéns!
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" v-for="item in userWithTreinosByCount1000" :key="item.id">
        <v-card class="elevation-10 mt-n2" :disabled="dialogLoader">
          <v-card-text class="body-2">
            <v-icon left color="primary">mdi-emoticon-cool-outline</v-icon>{{ item.fullName }}
            tem seu <span class="font-weight-black">1000º</span> treino conosco hoje! Dê os parabéns!
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="4" v-if="listTreinosDoDiaCorrida && listTreinosDoDiaCorrida.length > 0">
        <v-card class="elevation-10" dense :disabled="dialogLoader || dialogTreinoDetail">
          <v-card-title class="font-weight-black body-2">
            <v-icon left class="d-none d-md-flex">mdi-run-fast</v-icon>Treinos de corrida hoje
          </v-card-title>
          <v-card-text class="body-1">
            <v-list dense>
              <v-list-item v-for="item in listTreinosDoDiaCorrida" :key="item.treinoId">
                <v-list-item-avatar>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.fullName }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="loadTreino(item.treinoId)">
                    <v-icon color="primary">mdi-magnify</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="4" v-if="listTreinosDoDiaCiclismo && listTreinosDoDiaCiclismo.length > 0">
        <v-card class="elevation-10" dense :disabled="dialogLoader || dialogTreinoDetail">
          <v-card-title class="font-weight-black body-2">
            <v-icon left class="d-none d-md-flex">mdi-bike-fast</v-icon>Treinos de ciclismo hoje
          </v-card-title>
          <v-card-text class="body-1">
            <v-list dense>
              <v-list-item v-for="item in listTreinosDoDiaCiclismo" :key="item.treinoId">
                <v-list-item-avatar>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.fullName }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="loadTreino(item.treinoId)">
                    <v-icon color="primary">mdi-magnify</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="4" v-if="listTreinosDoDiaNatacao && listTreinosDoDiaNatacao.length > 0">
        <v-card class="elevation-10" dense :disabled="dialogLoader || dialogTreinoDetail">
          <v-card-title class="font-weight-black body-2">
            <v-icon left class="d-none d-md-flex">mdi-swim-fast</v-icon>Treinos de natação hoje
          </v-card-title>
          <v-card-text class="body-1">
            <v-list dense>
              <v-list-item v-for="item in listTreinosDoDiaNatacao" :key="item.treinoId">
                <v-list-item-avatar>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.fullName }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="loadTreino(item.treinoId)">
                    <v-icon color="primary">mdi-magnify</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>

    </v-row>

    <!-- Dialog for training details -->
    <div class="text-center">
      <v-dialog v-model="dialogTreinoDetail" hide-overlay persistent width="500">
        <v-card v-if="selectedTreino" class="fill-height">
          <v-card-title class="">
            Detalhes do treino
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon @click="selectedTreino = null; dialogTreinoDetail = false;">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="px-0">
            <card-treino v-bind:item="selectedTreino" :key="selectedTreino.id" :showAluno="true"/>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <!-- Loader for insights -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Espera um pouquinho...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>

//import axios from 'axios';
import HOST from '@/ws'
import CardTreino from '../../components/CardTreino.vue';
//import SnackBar from "../snackbar";


export default {
  props: {
    source: String
  },

  components : {
    CardTreino,
  },

  mounted () {

    this.loadPageData();
  },

  data: () => ({
    
    dialogLoader : false,

    userWithTreinosByCount100 : null,
    userWithTreinosByCount500 : null,
    userWithTreinosByCount1000 : null,

    listTreinosDoDiaCiclismo : null,
    listTreinosDoDiaCorrida : null,
    listTreinosDoDiaNatacao : null,

    selectedTreino : null,

    dialogTreinoDetail : false,

  }),

  methods : {

    async loadTreino(treinoId) {
      console.log('loading treino, id: ' + treinoId);
      this.dialogLoader = true;

      try {
        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
        };

        let response = await this.axios.get(HOST.HOST + '/treino/load-by-id?id=' + treinoId, config);
        this.selectedTreino = response.data;
        //console.log('\n' + JSON.stringify(response.data));
        this.dialogTreinoDetail = true;

      } catch (error) {
        console.error('Error loading insights data:', error);
        this.$store.commit("logout");
        this.$router.push("/");
      } finally {
        this.dialogLoader = false;
      }

    },

    async loadPageData(){

      try {
        this.dialogLoader = true;

        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
        };

        // Fetch users with the 100th treino
        let response = await this.axios.get(HOST.HOST + '/api/insights/users-by-treino-count?treinoCount=100', config);
        this.userWithTreinosByCount100 = response.data;

        // Fetch users with the 500th treino
        response = await this.axios.get(HOST.HOST + '/api/insights/users-by-treino-count?treinoCount=500', config);
        this.userWithTreinosByCount500 = response.data;

        // Fetch users with the 1000th treino
        response = await this.axios.get(HOST.HOST + '/api/insights/users-by-treino-count?treinoCount=1000', config);
        this.userWithTreinosByCount1000 = response.data;

        // Fetch all treinos de ciclismo do dia
        response = await this.axios.get(HOST.HOST + '/treino/load-treinos-do-dia-esporte?esporte=Corrida', config);
        this.listTreinosDoDiaCorrida = response.data;

        // Fetch all treinos de ciclismo do dia
        response = await this.axios.get(HOST.HOST + '/treino/load-treinos-do-dia-esporte?esporte=Ciclismo', config);
        this.listTreinosDoDiaCiclismo = response.data;

        // Fetch all treinos de natação do dia
        response = await this.axios.get(HOST.HOST + '/treino/load-treinos-do-dia-esporte?esporte=Natação', config);
        this.listTreinosDoDiaNatacao = response.data;


      } catch (error) {
        console.error('Error loading insights data:', error);
        this.$store.commit("logout");
        this.$router.push("/");
      } finally {
        this.dialogLoader = false;
      }

    }
  }
};
</script>